import { createSlice } from "@reduxjs/toolkit";

export const reportSlice = createSlice({
  name: "report",
  initialState: {
    getReportResult: false,
    getReportLoading: false,
    getReportError: false,
    addReportResult: false,
    addReportLoading: false,
    deleteReportResult: false,
  },
  reducers: {
    reportReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_REPORT":
          return {
            ...state,
            getReportResult: payload.data,
            getReportLoading: payload.loading,
            getReportError: payload.error,
          };
        default:
          return state;
      }
    },
  },
});

export const { reportReducers } = reportSlice.actions;

export default reportSlice.reducer;
